import { render, staticRenderFns } from "./switching.vue?vue&type=template&id=09599851&"
import script from "./switching.vue?vue&type=script&lang=js&"
export * from "./switching.vue?vue&type=script&lang=js&"
import style0 from "./switching.vue?vue&type=style&index=0&id=09599851&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports